import { createApp } from 'vue';
import { trans } from '@tools/translation';
import ContactOfferButton from '@components/ContactOfferButton.vue';

/* eslint-disable no-param-reassign */
const handleExpandableContent = (htmlButton, htmlContent) => {
  if (!htmlButton || !htmlContent) {
    return;
  }

  if (htmlContent.offsetHeight < 100) {
    htmlButton.remove();
    return;
  }

  htmlButton.addEventListener('click', () => {
    if (htmlContent.classList.contains('expanded')) {
      htmlContent.style.maxHeight = '100px';

      htmlContent.addEventListener('transitionend', () => {
        htmlButton.textContent = trans('office_offer.proposal_comment.see_more');
        htmlContent.classList.remove('expanded');
        htmlContent.style.maxHeight = null;
      }, { once: true });
    } else {
      htmlContent.style.maxHeight = '1500px';
      htmlContent.classList.add('expanded');
      htmlButton.textContent = trans('office_offer.proposal_comment.see_less');
    }
  });
};
/* eslint-enable no-param-reassign */

const mountContactOfferButtons = () => {
  document.querySelectorAll('.vue-contact-offer-button').forEach((element) => {
    createApp({ components: { ContactOfferButton } }).mount(element);
  });
};

export const offerDetails = () => {
  if (!document.querySelector('.offer-details')) {
    return;
  }

  // Set cross-sell tabs to 'author' on 'other offers' anchor click in sticky.
  if (document.querySelector('.ods__user .anchor') !== null) {
    document
      .querySelector('.ods__user .anchor')
      .addEventListener('click', () => {
        const userOffers = document.querySelector('.tabs__tab--author');
        userOffers.click();
      });
  }

  const stickyExpandButton = document.querySelector('.offer-details__sticky .proposal-comment__expanded-button');
  const stickyContent = document.querySelector('.offer-details__sticky .proposal-comment__content');

  const expandButton = document.querySelector('.offer-content .proposal-comment__expanded-button');
  const content = document.querySelector('.offer-content .proposal-comment__content');

  handleExpandableContent(stickyExpandButton, stickyContent);
  handleExpandableContent(expandButton, content);

  document.querySelector('.offer-services .offer-services__expand-button')?.addEventListener('click', () => {
    const offerServicesSection = document.querySelector('.offer-services');

    if (!offerServicesSection) {
      return;
    }

    offerServicesSection.classList.toggle('expanded');

    document.querySelector('.offer-services__expand-button').textContent = offerServicesSection.classList.contains('expanded')
      ? trans('office_offer.office_services.see_less') : trans('office_offer.office_services.see_more');
  });

  mountContactOfferButtons();
};
